class TokenService {
    getLocalRefreshToken() {
        const authentication = JSON.parse(localStorage.getItem("Authentication"));
        return authentication?.refresh_token;
    }
    getLocalAccessToken() {
        const authentication = JSON.parse(localStorage.getItem("Authentication"));
        return authentication?.access_token;
    }
    getAuthentication() {
        return JSON.parse(localStorage.getItem("Authentication"));
    }
    setAuthentication(authentication) {
        localStorage.setItem("Authentication", JSON.stringify(authentication));
    }
    removeAuthentication() {
        localStorage.removeItem("Authentication");
    }
}
export default new TokenService();